export default __webpack_public_path__ + "df6644a6ec79758349e4a485d9ec6bb6.png";